export interface ConfirmUserPhoneNumberModel {
  email: string;
  phone: string;
  code: string;
}
